// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiRequestSearchRequest {
    static getAttributeTypeMap() {
        return MedicalBiRequestSearchRequest.attributeTypeMap;
    }
}
MedicalBiRequestSearchRequest.discriminator = undefined;
MedicalBiRequestSearchRequest.additionalProperties = false;
MedicalBiRequestSearchRequest.attributeTypeMap = [
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "number"
    },
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalBiRequestSearchRequest.js.map